import React, { useContext, useState, useEffect } from "react";
import Panel from "../../UI/Panel/Panel";
import PanelContent from "../../UI/Panel/PanelContent";
import PanelTitle from "../../UI/Panel/PanelTitle";
import styled from "styled-components";
import { Button } from "../../../Theme/Hyper";
import Input from "../../UI/Form/Input";
import { SocketContext } from "../../../contexts/SocketContext";
import { HiSwitchHorizontal } from "react-icons/hi";
import { UIContext } from "../../../contexts/UIContext";
import percentRound from "percent-round";

const Row = styled.div`
  display: flex;
`;

const Half = styled.div`
  display: flex;
  flex-direction: column;
`;

const Tabs = styled.div`
  display: flex;
  margin-right: auto;
`;

const Tab = styled.div`
  background-color: ${(props) => (props.selected ? "#fff" : "#f2f2f2")};
  color: ${(props) => (props.selected ? "#606770" : "#999da0")};
  padding: 0.5em;
  display: flex;
  justify-content: center;
  min-width: 50px;
  border-top: 1px solid #dadde1;
  border-right: 1px solid #dadde1;
  border-left: ${(props) => (props.left ? "1px solid #dadde1" : "")};
  text-decoration: none;
  cursor: pointer;
`;

const SwitchButton = styled(Button)`
  height: 40px;
  font-size: 1em;
  margin-right: 0px;
  width: 33%;
`;

const Table = styled.table`
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  table-layout: fixed;
  > tbody > tr:nth-of-type(odd) {
    background-color: rgba(0, 0, 0, 0.05);
  }
  th:nth-child(1) {
    width: 65px;
  }
  th:nth-child(2) {
    width: 65px;
  }
  th:nth-child(3) {
    width: ${(props) => (props.showNumber ? "65px" : "")};
  }
  th {
    padding: 10px;
    border-top: 1px solid #dee2e6;
  }
  td {
    padding-left: 10px;
    padding-right: 10px;
    border-top: 1px solid #dee2e6;
    width: ${(props) => props.width};
    padding: 4px;
    padding-left: 10px;
    padding-right: 10px;
    border-top: 1px solid #dee2e6;
    white-space: nowrap;
    overflow: hidden;
    font-size: 0.8em;
  }
  > tbody > tr:hover {
    background-color: #14ec8e;
    color: white;
  }
  td.icons {
    padding: 0px;
    font-size: 20px;
    padding-top: 3px;
  }
`;

const TH = styled.th`
  border-top: 0;
  border-bottom: 0;
  font-weight: 800;
  font-size: 0.8em;
  text-transform: uppercase;
  color: #343a40;
  text-align: left;
`;

export default function OPTAActionAreas({
  fixture,
  possession,
  home_team,
  away_team,
}) {
  const { game, sendData } = useContext(SocketContext);
  const { selectedCompetition } = useContext(UIContext);

  const [view, setView] = useState(0);

  if (!fixture) {
    return <></>;
  }
  let ballPossession = possession?.possessionWave?.find(
    (p) => p.type === "territorialThird"
  );

  return (
    <Panel>
      <PanelTitle title="Action Areas"></PanelTitle>
      <PanelContent
        style={{
          justifyContent: "center",
          alignItems: "center",
          flexDirection: "column",
        }}
      >
        <Table>
          <thead>
            <tr>
              <TH></TH>
              <TH>{home_team?.code}</TH>
              <TH>Centre</TH>
              <TH>{away_team?.code}</TH>
            </tr>
          </thead>
          <tbody>
            {ballPossession?.intervalLength
              .find((i) => i.type === "45")
              ?.interval?.map((interval, index) => {
                let rounded = percentRound([
                  interval.home,
                  interval.middle,
                  interval.away,
                ]);
                return (
                  <tr>
                    <td>{interval.type}</td>
                    <td>{rounded[0]}</td>
                    <td>{rounded[1]}</td>
                    <td>{rounded[2]}</td>
                  </tr>
                );
              })}
            <Overall ballPossession={ballPossession} />
          </tbody>
        </Table>
      </PanelContent>
    </Panel>
  );
}

function Overall({ ballPossession }) {
  let rounded = percentRound([
    ballPossession?.overall?.home || 0,
    ballPossession?.overall?.middle || 0,
    ballPossession?.overall?.away || 0,
  ]);
  return (
    <tr>
      <td>Overall</td>
      <td>{rounded[0]}</td>
      <td>{rounded[1]}</td>
      <td>{rounded[2]}</td>
    </tr>
  );
}
